import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import Header from "../components/Header";
import Footer from "../components/Footer";

import googlePlay from "../assets/images/google-store.png";
import applePlay from "../assets/images/app-store.png";

import headerBanner from "../assets/images/HeaderBanner.png";
import sellYourProject from "../assets/images/sellYourProduct.png";
import buyYourProject from "../assets/images/buyYourProject.png";

import whyChooseUs from "../assets/images/whyChooseUs.png";
import blackTick from "../assets/images/black-tick.png";

import downloadApp from "../assets/images/downloadApp.png";

// Import AOS

// Line icons for the "App Featured" cards
const ICONS = {
  grid: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </svg>
  ),
  store: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l1.5-5h15L21 9" />
      <path d="M4 9v10a1 1 0 001 1h14a1 1 0 001-1V9" />
      <path d="M3 9a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0" />
      <path d="M10 20v-5h4v5" />
    </svg>
  ),
  gift: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <rect x="5" y="12" width="14" height="9" rx="1" />
      <path d="M12 8v13" />
      <path d="M12 8c-1.8 0-3.2-1.2-3.2-3S10.2 2 12 4c1.8-2 4.2-1.2 4.2 1S13.8 8 12 8z" />
    </svg>
  ),
  truck: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="12" height="10" rx="1" />
      <path d="M14 10h4l3 3v4h-7z" />
      <circle cx="7" cy="19" r="1.6" />
      <circle cx="17.5" cy="19" r="1.6" />
    </svg>
  ),
  shield: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v6c0 4.5-3 8-7 9-4-1-7-4.5-7-9V6z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  tag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 12.5L12.5 20a1.5 1.5 0 01-2.1 0l-6.4-6.4a1.5 1.5 0 010-2.1L11.5 4H19a1 1 0 011 1v7.5z" />
      <circle cx="15.5" cy="8.5" r="1.5" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.8z" />
    </svg>
  ),
  fridge: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="1.5" />
      <path d="M5 9h14" />
      <path d="M8 5v2" />
      <path d="M8 12v2.5" />
    </svg>
  ),
};

const FEATURES = [
  { icon: "grid", title: "Browse Categories", detail: ["Explore listings organised by", "category so you can find exactly", "what you're looking for, fast."] },
  { icon: "store", title: "Create Your Store", detail: ["Set up your own storefront with a", "logo, cover photos, and details in", "just a few minutes."] },
  { icon: "gift", title: "Sell or Gift Items", detail: ["List products for sale or mark", "them as a free gift to give back", "to your community."] },
  { icon: "truck", title: "Order Tracking", detail: ["Follow every order in real time,", "from acceptance and dispatch", "to delivery at your door."] },
  { icon: "shield", title: "Secure Payments", detail: ["Pay your way with card, Apple", "Pay, or cash on delivery — every", "transaction is protected."] },
  { icon: "tag", title: "Promo Codes", detail: ["Save more with promo codes", "and seasonal discounts on", "your favourite items."] },
  { icon: "star", title: "Ratings & Reviews", detail: ["Shop with confidence using", "honest ratings and reviews left", "by other buyers."] },
  { icon: "fridge", title: "Community Food Fridges", detail: ["Find nearby food fridges on the", "map, or add a new one to help", "your community."] },
];

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const targetId = location.state?.scrollTo;
    if (!targetId) return;

    const timer = setTimeout(() => {
      scroller.scrollTo(targetId, { smooth: true, duration: 300 });
    }, 100);

    return () => clearTimeout(timer);
  }, [location.state]);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollPosition = window.scrollY;
  //     const moveX = scrollPosition * 0.5;
  //     setScrollX(moveX);
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

 
  return (
    <>
      <div className="main-bg pb-5">
        <Header />
        {/* Banner Sec */}
        <div className="container header-banner bg-gradient" id="home">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="header-txt1" data-aos="fade-up">
                <h1
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="heading-texti text-center hover-scale-sm"
                >
                  Buy, Sell, Gift & Give Back <br />
                  All In One Community App
                </h1>
              </div>
              <div className="d-flex justify-content-center align-items-center" data-aos="zoom-in" data-aos-delay="250">
                <img src={headerBanner} className="mobile-banner-imgs hover-scale-sm" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us */}
      <div className="container aboutUs-main" id="about">
        <div className="text-center" data-aos="fade-up">
          <h2 className="text-black about-heading">About Bazarna</h2>
          <p className="about-desc">
            A community marketplace for the UAE — shop, connect, and share
            with ease, all in one app.
          </p>
        </div>
        <div className="row my-2 g-4 about-cards justify-content-center">
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="about-card about-card--red hover-rise-sm">
              <div className="about-card__header">
                Buy, Sell & Gift
              </div>
              <div className="about-card__body">
                <p>
                  List items to sell or gift to your community in a few taps.
                  Browse by category, chat with sellers, and pay securely by
                  card, Apple Pay, or cash on delivery.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div className="about-card about-card--green hover-rise-sm">
              <div className="about-card__header">
                Discover Home Businesses
              </div>
              <div className="about-card__body">
                <p>
                  Find local home-based sellers near you, explore their
                  storefronts, and support small businesses in your own
                  neighbourhood.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 col-md-6 col-12"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <div className="about-card about-card--yellow hover-rise-sm">
              <div className="about-card__header">
                Community Food Fridges
              </div>
              <div className="about-card__body">
                <p>
                  Locate nearby community food fridges on the map, or add a
                  new one to help reduce food waste and support those around
                  you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Employee App Section */}
      <div className="container py-5 employee-app-section" id="employeeApp">
        <div className="row align-items-center">
          {/* Left Column - Text Content */}
          <div
            className="col-lg-6 position-relative"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <div className="employee-img">
              <div className="employee-large-phone">
                <img
                  src={sellYourProject}
                  alt="Employee App Yellow"
                  className="phone-mockup-large hover-scale-sm"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Large Yellow Phone */}
          <div
            className="col-lg-6 employee-app-section-right-column"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="app-section-content">
              <h2 className="app-section-title hover-scale-sm">Sell Your Products</h2>
              <p className="app-section-detail">
                Set up your own store in minutes and start <br />
                reaching buyers across the UAE.
              </p>
              <p className="app-section-description">
                Create your storefront, list items for sale or gift, and manage
                <br className="br" />
                orders from one dashboard. Track every sale, get paid straight
                <br className="br" />
                to your wallet, and grow your business right from the app.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company App Section */}
      <div className="container py-5 employee-app-section" id="companyApp">
        <div className="row align-items-center">
          {/* Left Column */}
          <div
            className="col-lg-6 company-app-section-left-column"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <h2 className="app-section-title">Buy What You Need</h2>
            <p className="app-section-detail">
              Browse thousands of listings from sellers <br />
              and home businesses near you.
            </p>
            <p className="app-section-description">
              Search by category, compare prices, and message sellers
              <br />
              directly. Checkout securely with card, Apple Pay, or cash on
              <br />
              delivery, then track your order right up to your door.
            </p>
          </div>

          {/* Right Column */}
          <div
            className="col-lg-6 position-relative"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div className="company-img">
              <div className="employee-large-phone">
                <img
                  src={buyYourProject}
                  alt="Employee App Yellow"
                  className="phone-mockup-large-blue hover-scale-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="container my-5" id="whyChooseUs">
        <div className="row">
          <div className="col-md-6 d-flex justify-content-center align-items-center" data-aos="fade-right">
            <div>
              <img src={whyChooseUs} className="whyChooseUs-img hover-scale-sm" alt="" />
            </div>
          </div>
          <div className="col-md-6" data-aos="fade-left" data-aos-delay="150">
            <div className="why-choose-us-content">
              <h2 className="app-section-title hover-scale-sm">Why Choose Us</h2>
              <p className="app-section-detail">
                Everything a community marketplace should be — <br />
                simple, safe, and built for the UAE
              </p>
              <p className="app-section-description">
                From your first listing to your last delivery, Bazarna keeps
                buying, selling, gifting, and giving back effortless — with
                secure payments and real people behind every transaction.
              </p>
              <ul className="whyChooseUs-unOrder-list">
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="100">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    Buy, sell, or gift items with verified local sellers
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="150">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    Secure checkout with card, Apple Pay, or cash on delivery
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="200">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    Real-time order tracking from checkout to delivery
                  </span>
                </li>
                <li className="whyChooseUs-list d-flex hover-rise-sm" data-aos="zoom-in" data-aos-delay="250">
                  <div className="black-tick d-flex align-items-center justify-content-center rounded-pill">
                    <img src={blackTick} alt="" className="hover-scale-sm" />
                  </div>
                  <span>
                    Community food fridges to help reduce food waste
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* App Featured */}
      <div className="container my-5" id="featured">
        <div className="row">
          <div className="col-md-12">
            <h2 className="app-section-title text-center hover-scale-sm w-100" data-aos="fade-up">App Featured</h2>
            <p className="app-section-detail text-center" data-aos="fade-up">
              Everything you need to buy, sell, gift, and give back — built
              into one app
            </p>
          </div>
        </div>
        <div className="row g-4 app-featured-row">
          {FEATURES.map((feature, i) => (
            <div
              className="col-md-6 col-lg-3"
              key={feature.title}
              data-aos="zoom-in"
              data-aos-delay={100 + i * 50}
            >
              <div className="app-featured-box hover-rise-sm">
                <div className="app-featured-icon">
                  {ICONS[feature.icon]}
                </div>
                <h3 className="app-featured-title">{feature.title}</h3>
                <p className="app-featured-detail text-center">
                  {feature.detail.map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      {idx < feature.detail.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Download our App */}
      <div className="container download-App-main" id="downloadApp" data-aos="fade-up">
        <img
          src={downloadApp}
          className="download-img-section img-fluid"
          alt=""
        />
        <div className="row downloadApp">
          <div
            className="col-md-6 offset-md-6 text-white d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <p className="appDown-section-detail mb-2">Bazarna helps you</p>

            <h1 className="appDown-section-title hover-scale-sm">Sell Your Products & Earn</h1>
            <p className="appDown-section-description">
              Download the app to buy, sell, gift, and discover <br />
              community food fridges near you — all in the UAE.
            </p>

            <div
              className="btn-download-app"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <a
                href="https://play.google.com/store/apps/details?id=com.bazarna"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googlePlay}
                  style={{
                    width: "186px",
                    height: "58px",
                    marginRight: "10px",
                  }}
                  className="hover-scale-sm"
                />
              </a>
              <a
                href="https://apps.apple.com/ae/app/bazarna/id6757228776"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={applePlay}
                  style={{ width: "197px", height: "58px" }}
                  className="hover-scale-sm"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default HomePage;
